import {
  CalendarDays,
  ClipboardCheck,
  ContactRound,
  LayoutDashboard,
  MessageCircle,
  Settings,
  UserRound,
  UsersRound,
} from 'lucide-react'
import { AppShell } from './AppShell'
import { useAuth } from '../providers/auth-context'
import type { NavigationSection } from './navigation'

export function AlumniLayout() {
  const { access } = useAuth()
  const sections: NavigationSection[] = [
    {
      label: 'Utama',
      items: [{ to: '/app', label: 'Ringkasan', icon: LayoutDashboard, end: true }],
    },
    {
      label: 'Komuniti',
      items: [
        { to: '/app/directory', label: 'Direktori alumni', icon: ContactRound },
        { to: '/app/events', label: 'Acara', icon: CalendarDays },
        { to: '/app/communities', label: 'Komuniti', icon: UsersRound },
        { to: '/app/messages', label: 'Mesej', icon: MessageCircle },
      ],
    },
    {
      label: 'Akaun',
      items: [
        { to: '/app/profile', label: 'Profil saya', icon: UserRound },
        { to: '/app/settings', label: 'Tetapan', icon: Settings },
      ],
    },
    ...(access?.canAccessAdmin
      ? [
          {
            label: 'Pentadbiran',
            items: [
              {
                to: '/admin/applications',
                label:
                  access.adminScope === 'operations'
                    ? 'Ruang pentadbiran'
                    : `Semakan Batch ${access.adminBatchYear ?? ''}`.trim(),
                icon: ClipboardCheck,
              },
            ],
          },
        ]
      : []),
  ]
  return <AppShell sections={sections} />
}
